function getPasswordStrength(password) {
  let score = 0

  if (!password) return 0
  if (password.length >= 6) score++
  if (/[A-Z]/.test(password) && /[a-z]/.test(password)) score++
  if (/\d/.test(password)) score++
  if (/[!@#$%^&*?_~]/.test(password)) score++

  return Math.min(score, 4)
}

function updateStrengthIndicator(inputWrapper, value) {
  const bars = inputWrapper.querySelectorAll(".js-password-input-strength-indicator [class*='__bar-']")
  const message = inputWrapper.querySelector(".js-password-input-strength-indicator__message")

  const strength = getPasswordStrength(value)

  const levels = [
    { text: "Too weak", color: "tw-bg-red-500" },
    { text: "Weak", color: "tw-bg-orange-400" },
    { text: "Medium", color: "tw-bg-yellow-400" },
    { text: "Strong", color: "tw-bg-green-500" },
  ]

  bars.forEach((bar, index) => {
    bar.classList.remove(
      "tw-bg-red-500",
      "tw-bg-orange-400",
      "tw-bg-yellow-400",
      "tw-bg-green-500"
    )
    if (index < strength) bar.classList.add(levels[strength - 1].color)
    else bar.classList.add("tw-bg-neutral-400")
  })

  if (message) {
    message.textContent = strength > 0 ? levels[strength - 1].text : "Too weak"
  }
}

function setupToggleVisibility(inputWrapper) {
  const toggleView = inputWrapper.querySelector(".js-password-input__toggle")
  const input = inputWrapper.querySelector("input[type='password'], input[type='text']")

  if (!toggleView || !input) return

  const toggleVisibility = () => {
    const expanded = toggleView.getAttribute("aria-expanded") === "false"
    input.type = expanded ? "text" : "password"
    toggleView.setAttribute("aria-expanded", String(expanded))
    toggleView.textContent = expanded ? "hide" : "show"
    toggleView.setAttribute("aria-label", expanded ? "Hide password" : "Show password")
  }

  toggleView.addEventListener("click", (e) => {
    e.preventDefault()
    toggleVisibility()
  })

  toggleView.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault()
      toggleVisibility()
    }
  })
}

function initPasswordInput(inputWrapper) {
  if (!inputWrapper) return

  const input = inputWrapper.querySelector("input[type='password']")
  const indicator = inputWrapper.querySelector(".js-password-input-strength-indicator")

  setupToggleVisibility(inputWrapper)

  if (indicator && input) {
    input.addEventListener("input", () => {
      updateStrengthIndicator(inputWrapper, input.value)
    })
  }
}

function initializePasswordInputs() {
  const passwordInputs = document.querySelectorAll(".js-password-input")
  passwordInputs.forEach(initPasswordInput)
}


initializePasswordInputs()
